<template>
  <ankh-list :showSearchForm="false">
    <template #btn-group>
      <el-button @click.native="handleShowFormDialog()">{{$t('新增')}}</el-button>
    </template>

    <template #table="{height}">
      <table-list
          ref="list"
          row-key="id"
          :height="height"
          @query="handleSearch"
          :search-params="searchForm"
          :data="tableData"
          :indent="16"
          @selection-change="selection = $event">

        <el-table-column type="selection" width="50"/>
        <el-table-column type="index" :label="$t('序号')" width="50" fixed />

        <el-table-column prop="rewardPrice" :label="$t('打赏金额')" fixed />
        <el-table-column prop="price" :label="$t('金额')" />
        <el-table-column :label="$t('更新时间')">
          <template v-slot="{row}">
            {{row.updateTime | formatDate}}
          </template>
        </el-table-column>
        <el-table-column fixed="right" :label="$t('操作')" min-width="40">
          <template v-slot="{row}">
            <div class="fb-link-flex">
              <el-link type="primary" :underline="false" @click="handleShowFormDialog(row)">{{$t('编辑')}}</el-link>
              <el-link type="danger" :underline="false" @click="handleDelete(row)">{{$t('删除')}}</el-link>
            </div>
          </template>
        </el-table-column>
      </table-list>
    </template>
    <template slot="other">
      <award-form ref="awardForm" :is-edit="isEdit" :data="currentRow" @save="handleSubmitByAddOrEdit" />
    </template>
  </ankh-list>
</template>

<script>
import {request, requestByTip} from "@/config/request";
import TableList from "@/components/table-list/TableList";
import AwardForm from "@/components/award-form/AwardForm";
import AnkhList from "@/components/list/AnkhList.vue";

export default {
  name: "AwardList",
  components: {AnkhList, AwardForm, TableList},
  data() {
    return {
      searchForm: {},
      tableData: [],
      selection: [],
      currentRow: {},
      isEdit: false,
    }
  },
  methods: {
    // 提交
    async handleSubmitByAddOrEdit(data) {
      try {
        let params = data;
        const action = this.$api.reward[this.isEdit ? 'update' : 'add'];
        if(this.isEdit) {
          params = Object.assign(this.currentRow, data);
          delete params.createTime;
          delete params.updateTime;
        }
        await request(action, params);
        this.$message.success(this.$t("操作成功"));
        this.$refs.list.handleSearch();
        this.$refs.awardForm.showDialog = false;
      } catch (e) {
        console.log(e);
      }
    },

    // 打开表单弹窗
    handleShowFormDialog(row) {
      if(row) {
        this.currentRow = {...row};
        this.isEdit = true;
      } else {
        this.isEdit = false;
      }
      this.$refs.awardForm.showDialog = true;
    },

    async handleDelete(row) {
      try {
        await requestByTip(this.$api.reward.delete, {code: row.code});
        this.$message.success(this.$t("操作成功"))
        this.$refs.list.handleRequest();
      } catch (e) {
        console.error(e);
      }
    },

    async handleBatchDelete() {
      if (!this.selection.length) {
        this.$message({
          type: 'warning',
          message: this.$t("未选择记录")
        });
        return;
      }
      try {
        let codes = this.selection.map(item => item.code);
        await requestByTip(
            this.$api.reward.batchDelete,
            codes,
            {isJson: true},
            {message: this.$t("您现在正在进行批量删除操作, 是否继续?")}
        );
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest();

      } catch (e) {
        console.error(e);
      }
    },

    async handleSearch(params, setTotal) {
      try {
        let res = await request(this.$api.reward.list, params);
        for (let key in res) {
          if (res[key] instanceof Array) {
            this.tableData = res[key];
          }
        }
        setTotal(res.pager?.itemCount);
      } catch (e) {
        console.error(e);
      }
    }
  },
}
</script>

<style scoped>


</style>
